// Copia texto al portapapeles de forma segura (con fallback para iframes/preview
// donde navigator.clipboard puede rechazar por permisos).
export function copyToClipboard(text) {
  try {
    const p = navigator.clipboard?.writeText(text);
    if (p && typeof p.catch === "function") p.catch(() => fallbackCopy(text));
    else if (!p) fallbackCopy(text);
  } catch (e) {
    fallbackCopy(text);
  }
}

function fallbackCopy(text) {
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.top = "-9999px";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    document.execCommand("copy");
    document.body.removeChild(ta);
  } catch (e) {
    /* noop */
  }
}
